<template>
  <div class="story-container">
    <div class="story-image">
      <img v-for="(image, index) in images" :key="index" :src="image" :alt="'Immagine storia ' + (index + 1)" />
    </div>
    <div class="story-content">
      <h2 class="story-title">{{ title }}</h2>
      <p class="story-text">{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StoryComponent',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    images: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
.story-container {
  margin: auto;
  margin-top: 50px;
  width: 95vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: var(--primary-color);
  color: var(--text-color);
  border-radius: 10px;
  box-shadow: var(--custom-box-shadow);
}
.story-image {
  flex: 50%;
}
.story-image img {
  width: 100%;
  height: auto;
  border-radius: 10px;
  margin: 10px;
}

.story-content {
  flex: 0 0 50%;
  margin-left: 20px;
}

.story-title {
  height: 40px;
  position: relative;
  font-size: 24px;
  margin-bottom: 10px;
  margin: auto;
}

.story-text {
  font-size: 16px;
  line-height: 1.6;
}
</style>
